// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3KvcZ","backBtn":"styles_backBtn__2q8d6"};